const s = {
  guidance: "var(--plac-icon-outline)",
  error: "var(--plac-status-error)",
  success: "var(--plac-status-success)"
};
export {
  s as STATE_TO_ICON_COLOR_MAPPING
};
//# sourceMappingURL=index.es5838.js.map
